<tour-step-template
  *ngIf="isVisible"
  [class]="activeTour.mainAnchorId"
  [attr.step]="activeTour.steps[currentStep - 1].anchorId"
>
  <ng-template let-step="step">
    <div
      *ngIf="stepsLength"
      class="coachmark"
      [ngClass]="['coachmark-' + theme]"
      (click)="$event.stopPropagation()"
    >
      <!-- Temporally hidde position mark and close button -->
      <div class="coachmark-header" *ngIf="stepsLength > 1">
        <p class="coachmark-header__step-indicator">
          {{ currentStep }}/{{ stepsLength }}
        </p>
        <a class="coachmark-header__close-button" (click)="endTour()">
          <img src="/images/atm-icn-cancel-white.svg" alt="atm_icn_cancel"
        /></a>
      </div>

      <div
        *ngIf="step.content && !activeTour.isMultilineTitle"
        class="coachmark-text"
      >
        <p>
          <span *ngIf="step.title" class="coachmark-text--header"
            >{{ step?.title }}&nbsp;</span
          >{{ step?.content }}
        </p>
      </div>
      <div
        *ngIf="step.content && activeTour.isMultilineTitle"
        class="coachmark-text"
      >
        <span *ngIf="step.title" class="coachmark-text--header">{{
          step?.title
        }}</span>
        <p>
          {{ step?.content }}
        </p>
      </div>
      <div class="coachmark-action-buttons">
        <button
          *ngIf="isSecuenceButtons && currentStep > 1"
          type="button"
          class="link link--light link--borderless link--borderless-bold"
          (click)="prevStep()"
        >
          Anterior
        </button>
        <button
          *ngIf="isSecuenceButtons && currentStep !== stepsLength"
          type="button"
          class="link link--light link--borderless link--borderless-bold"
          (click)="nextStep()"
        >
          Siguiente
          <img
            src="/images/icons/chevron-next-white.svg"
            alt="chevron_next_white"
          />
        </button>
        <button
          *ngIf="!isSecuenceButtons || currentStep === stepsLength"
          type="button"
          class="link link--light link--borderless link--borderless-bold"
          (click)="endTour()"
        >
          Entendido
        </button>
      </div>
    </div>
  </ng-template>
</tour-step-template>
